{
  "MMM Do YYYY, h:mm a": "D MMM YYYY, HH:mm",
  "MMM Do YYYY": "D MMM YYYY",
  "Wedding": "Ślub",
  "Funeral": "Pogrzeb",
  "Birthday": "Urodziny",
  "School": "Szkoła",
  "Sport": "Sport",
  "event type|Other": "Inne",
  "Audio/video professional": "Realizacja audio i wideo",
  "Funeral home owner or director": "Prowadzenie domu pogrzebowego",
  "Event planner or venue manager": "Organizacja wydarzeń lub zarządzanie obiektem",
  "Church, pastor, preacher or minister": "Kościół lub duszpasterstwo",
  "Teacher or school manager": "Nauczanie lub zarządzanie szkołą",
  "Nonprofit or charity": "Organizacja non-profit lub charytatywna",
  "Live event streamer or producer": "Transmisja lub produkcja wydarzeń na żywo",
  "role|Other": "Inne",
  "room noun|room": "sala",
  "room noun|stage": "scena",
  "room noun|track": "tor",
  "room noun|court": "kort",
  "room noun|field": "boisko",
  "room noun|hall": "hala",
  "room noun|camera": "kamera",
  "Sorry, we need camera roll permissions to make this work!": "Przepraszamy, aby to działało, potrzebujemy dostępu do twoich zdjęć.",
  "Streaming Permissions Required": "Wymagane uprawnienia do transmisji",
  "EventLive cannot open streaming until camera, microphone, and recording permissions are enabled.": "EventLive nie może otworzyć transmisji, dopóki nie włączysz uprawnień do kamery, mikrofonu i nagrywania.",
  "Search for an event": "Szukaj wydarzenia",
  "Schedule your first service": "Zaplanuj pierwszą uroczystość",
  "Create your first event": "Utwórz pierwsze wydarzenie",
  "Each service gets a private link to share with the family. Families watch on any device, with no app or login.": "Każda uroczystość ma prywatny link, który przekazujesz rodzinie. Rodzina ogląda na dowolnym urządzeniu, bez aplikacji i logowania.",
  "It looks like you have no events at the moment. Create one to see it here": "Wygląda na to, że na razie nie masz żadnych wydarzeń. Utwórz wydarzenie, aby zobaczyć je tutaj",
  "Schedule a Service": "Zaplanuj uroczystość",
  "Create an Event": "Utwórz wydarzenie",
  "You have {count} event credit. Each service day uses one.": {
    "one": "Masz {count} kredyt na wydarzenie. Każdy dzień uroczystości zużywa jeden.",
    "few": "Masz {count} kredyty na wydarzenia. Każdy dzień uroczystości zużywa jeden.",
    "many": "Masz {count} kredytów na wydarzenia. Każdy dzień uroczystości zużywa jeden."
  },
  "You have {count} event credit. Each event day uses one.": {
    "one": "Masz {count} kredyt na wydarzenie. Każdy dzień wydarzenia zużywa jeden.",
    "few": "Masz {count} kredyty na wydarzenia. Każdy dzień wydarzenia zużywa jeden.",
    "many": "Masz {count} kredytów na wydarzenia. Każdy dzień wydarzenia zużywa jeden."
  },
  "You have {count} prepaid event – it will be used for this event.": {
    "one": "Masz {count} wydarzenie opłacone z góry – wykorzystamy je na to wydarzenie.",
    "few": "Masz {count} wydarzenia opłacone z góry – jedno wykorzystamy na to wydarzenie.",
    "many": "Masz {count} wydarzeń opłaconych z góry – jedno wykorzystamy na to wydarzenie."
  },
  "Leave": "Wyjdź",
  "Keep editing": "Edytuj dalej",
  "Leave without scheduling the service?": "Wyjść bez zaplanowania uroczystości?",
  "Leave without scheduling the event?": "Wyjść bez zaplanowania wydarzenia?",
  "Schedule your live fundraiser": "Zaplanuj zbiórkę na żywo",
  "Schedule a service": "Zaplanuj uroczystość",
  "Schedule your first event": "Zaplanuj pierwsze wydarzenie",
  "Schedule your event": "Zaplanuj swoje wydarzenie",
  "Next, you'll confirm {organization} as the organization receiving donations. You can change the details later.": "Następnie potwierdzisz, że darowizny otrzyma {organization}. Szczegóły możesz zmienić później.",
  "Next, you'll choose the organization receiving donations. You can change the details later.": "Następnie wybierzesz organizację, która otrzyma darowizny. Szczegóły możesz zmienić później.",
  "The family gets one private link to watch live or later. You can change the details any time.": "Rodzina dostaje jeden prywatny link do oglądania na żywo lub później. Szczegóły możesz zmienić w każdej chwili.",
  "You can change the details later.": "Szczegóły możesz zmienić później.",
  "Are you sure you want to delete {title} and its {count} stage?": {
    "one": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego scenę?",
    "few": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} sceny?",
    "many": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} scen?"
  },
  "Are you sure you want to delete {title} and its {count} track?": {
    "one": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego tor?",
    "few": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} tory?",
    "many": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} torów?"
  },
  "Are you sure you want to delete {title} and its {count} court?": {
    "one": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego kort?",
    "few": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} korty?",
    "many": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} kortów?"
  },
  "Are you sure you want to delete {title} and its {count} field?": {
    "one": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego boisko?",
    "few": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} boiska?",
    "many": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} boisk?"
  },
  "Are you sure you want to delete {title} and its {count} hall?": {
    "one": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego halę?",
    "few": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} hale?",
    "many": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} hal?"
  },
  "Are you sure you want to delete {title} and its {count} camera?": {
    "one": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego kamerę?",
    "few": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} kamery?",
    "many": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} kamer?"
  },
  "Are you sure you want to delete {title} and its {count} room?": {
    "one": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego salę?",
    "few": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} sale?",
    "many": "Czy na pewno chcesz usunąć wydarzenie „{title}” i jego {count} sal?"
  },
  "Could not delete event": "Nie udało się usunąć wydarzenia",
  "Are you sure you want to delete {title}?": "Czy na pewno chcesz usunąć „{title}”?",
  "This action cannot be undone.": "Tej operacji nie można cofnąć.",
  "Delete Event": "Usuń wydarzenie",
  "Deleting Event...": "Usuwanie wydarzenia...",
  "Delete {camera}": "Usuń: {camera}",
  "How to Go Live": "Jak rozpocząć transmisję",
  "Guest List & Invite": "Lista gości i zaproszenia",
  "Title, Date, Time, Event Link, Uploads": "Tytuł, data, godzina, link do wydarzenia, pliki",
  "Add Another Camera Angle": "Dodaj kolejne ujęcie kamery",
  "Add a Room, Stage or Track": "Dodaj salę, scenę lub tor",
  "Chat": "Czat",
  "Privacy Settings": "Ustawienia prywatności",
  "Event Branding": "Branding wydarzenia",
  "Event Analytics": "Statystyki wydarzenia",
  "Expiring soon": "Wkrótce wygasa",
  "Storage expiry": "Koniec okresu przechowywania",
  "You're invited to watch {title}": "Zapraszamy do oglądania: {title}",
  "Guests use your main link and switch to this camera there. Stream it from its own phone.": "Goście korzystają z twojego głównego linku i tam przełączają się na tę kamerę. Do jej transmisji użyj osobnego telefonu.",
  "Share this link: guests switch between the cameras while they watch. Each camera streams from its own phone.": "Udostępnij ten link: goście przełączają się między kamerami podczas oglądania. Każda kamera transmituje z osobnego telefonu.",
  "Guests use the main link and switch {noun}s on the event page. This {noun} streams with its own key.": "Goście korzystają z głównego linku i na stronie wydarzenia przełączają się między transmisjami. Ta transmisja ({noun}) ma własny klucz.",
  "Share this link: guests switch {noun}s on the event page. Each {noun} streams with its own key.": "Udostępnij ten link: goście przełączają się między transmisjami na stronie wydarzenia. Każda transmisja ({noun}) ma własny klucz.",
  "Your event link:": "Link do twojego wydarzenia:",
  "{days}-day event:  Unlock with {count} more credit": {
    "one": "Wydarzenie {days}-dniowe: odblokuj za {count} dodatkowy kredyt",
    "few": "Wydarzenie {days}-dniowe: odblokuj za {count} dodatkowe kredyty",
    "many": "Wydarzenie {days}-dniowe: odblokuj za {count} dodatkowych kredytów"
  },
  "Unlock with {count} credit": {
    "one": "Odblokuj za {count} kredyt",
    "few": "Odblokuj za {count} kredyty",
    "many": "Odblokuj za {count} kredytów"
  },
  "{days}-day event: Unlock with {count} prepaid events": "Wydarzenie {days}-dniowe: odblokuj za pomocą {count} wydarzeń opłaconych z góry",
  "{days}-day event: Unlock with your prepaid event": "Wydarzenie {days}-dniowe: odblokuj za pomocą wydarzenia opłaconego z góry",
  "Unlock with {count} prepaid events": "Odblokuj za pomocą {count} wydarzeń opłaconych z góry",
  "Unlock with your prepaid event": "Odblokuj za pomocą wydarzenia opłaconego z góry",
  "Your private event link is scheduled to expire on {date}. Keep your event page, the video and the guestbook online for 1 more year, or for 10 years.": "Prywatny link do twojego wydarzenia wygaśnie {date}. Zachowaj stronę wydarzenia, wideo i księgę gości online jeszcze przez 1 rok albo na 10 lat.",
  "Keep My Memories Online Longer": "Zachowaj wspomnienia online na dłużej",
  "Download & View Stats": "Pobierz i zobacz statystyki",
  "This Event is in the Secure Archive.": "To wydarzenie znajduje się w bezpiecznym archiwum.",
  "The public streaming period for this event has ended. The streaming link has expired, but the memories are safe in our archive.": "Okres publicznego udostępniania tego wydarzenia dobiegł końca. Link do transmisji wygasł, ale wspomnienia są bezpieczne w naszym archiwum.",
  "Restore this Event": "Przywróć to wydarzenie",
  "Unlock cameras": "Odblokuj kamery",
  "{days}-Day Event: {start} – {end}": "Wydarzenie {days}-dniowe: {start} – {end}",
  "Expires in {count} day": {
    "one": "Wygasa za {count} dzień",
    "few": "Wygasa za {count} dni",
    "many": "Wygasa za {count} dni"
  },
  "Event is in the Secure Archive": "Wydarzenie jest w bezpiecznym archiwum",
  "Extend": "Przedłuż",
  "Use credit": "Użyj kredytu",
  "Use prepaid event": "Użyj wydarzenia opłaconego z góry",
  "Could not unlock the event": "Nie udało się odblokować wydarzenia",
  "Pay As You Go": "Płatność za wydarzenie",
  "Couldn't schedule the service": "Nie udało się zaplanować uroczystości",
  "Couldn't schedule the event": "Nie udało się zaplanować wydarzenia",
  "Service title": "Tytuł uroczystości",
  "e.g. Celebration of Life for Jane Doe": "np. Uroczystość pożegnalna Anny Kowalskiej",
  "e.g. Anna & Mark's wedding": "np. Ślub Anny i Marka",
  "your-event-link": "twoje-wydarzenie",
  "Available": "Link dostępny",
  "Event type": "Rodzaj wydarzenia",
  "Choose the type of event": "Wybierz rodzaj wydarzenia",
  "When the service starts": "Kiedy zaczyna się uroczystość",
  "When the event starts": "Kiedy zaczyna się wydarzenie",
  "Make it a multi-day event": "Ustaw jako wydarzenie wielodniowe",
  "Raise donations for a nonprofit": "Zbieraj darowizny dla organizacji non-profit",
  "Viewers can donate on your event page. You'll choose the organization after the event is created.": "Widzowie mogą przekazywać darowizny na stronie twojego wydarzenia. Organizację wybierzesz po utworzeniu wydarzenia.",
  "Schedule service": "Zaplanuj uroczystość",
  "Schedule event": "Zaplanuj wydarzenie",
  "Event details": "Szczegóły wydarzenia",
  "{room} follows the main event's date, time and days. Change them there and every {noun} moves with it.": "{room} ma datę, godzinę i dni głównego wydarzenia. Zmień je tam, a każda transmisja ({noun}) przesunie się razem z nim.",
  "Changes here apply to all {noun}s. Extra days are charged per {noun}.": "Zmiany wprowadzone tutaj dotyczą każdej transmisji ({noun}). Dodatkowe dni są płatne osobno za każdą z nich.",
  "Title and location": "Tytuł i miejsce",
  "Test events keep their name.": "Wydarzenia testowe zachowują swoją nazwę.",
  "e.g. St. Mary's Church, Austin": "np. Kościół Mariacki, Kraków",
  "Links and files": "Linki i pliki",
  "Shown under the video on your event page: a registry, a donation page, a website or a program.": "Wyświetlane pod wideo na stronie twojego wydarzenia: lista prezentów, strona zbiórki, strona internetowa lub program.",
  "Event rescheduled": "Zmieniono termin wydarzenia",
  "Guests will see the new date.": "Goście zobaczą nową datę.",
  "Couldn't change the date": "Nie udało się zmienić daty",
  "Event date and time": "Data i godzina wydarzenia",
  "Choose the event's local date and time": "Wybierz lokalną datę i godzinę wydarzenia",
  "Save date and time": "Zapisz datę i godzinę",
  "Change Link": "Zmień link",
  "Change event link?": "Zmienić link do wydarzenia?",
  "If you've already shared the current link with guests, they won't be able to access the event with the old link anymore. Are you sure you want to proceed?": "Jeśli obecny link został już udostępniony gościom, nie będą mogli otworzyć wydarzenia za pomocą starego linku. Czy na pewno chcesz kontynuować?",
  "Event link changed": "Zmieniono link do wydarzenia",
  "Couldn't change the link": "Nie udało się zmienić linku",
  "Share this link with your guests.": "Udostępnij ten link gościom.",
  "your-event-name": "nazwa-twojego-wydarzenia",
  "Copy event link": "Kopiuj link do wydarzenia",
  "Guests who already have the old link won't be able to open the event with it.": "Goście, którzy mają stary link, nie otworzą za jego pomocą wydarzenia.",
  "Change link": "Zmień link",
  "Edit {title}": "Edytuj: {title}",
  "Edit link": "Edytuj link",
  "Add a name": "Dodaj nazwę",
  "Add a web address": "Dodaj adres internetowy",
  "Open {title}": "Otwórz: {title}",
  "Open link": "Otwórz link",
  "Remove {title}": "Usuń: {title}",
  "Remove link": "Usuń link",
  "File name guests see": "Nazwa pliku widoczna dla gości",
  "Link text": "Tekst linku",
  "e.g. Order of service": "np. Program uroczystości",
  "e.g. Our registry": "np. Nasza lista prezentów",
  "Web address": "Adres internetowy",
  "Add link": "Dodaj link",
  "File added": "Dodano plik",
  "Guests can open it from the event page.": "Goście mogą go otworzyć na stronie wydarzenia.",
  "Removed \"{title}\"": "Usunięto „{title}”",
  "Removed \"link\"": "Usunięto link",
  "Tap to undo": "Stuknij, aby cofnąć",
  "Uploading…": "Przesyłanie…",
  "Upload file": "Prześlij plik",
  "file type|Text": "Tekst",
  "file type|Image": "Obraz",
  "file type|File": "Plik",
  "Document": "Dokument",
  "Add the text guests will see.": "Dodaj tekst, który zobaczą goście.",
  "Add the web address.": "Dodaj adres internetowy.",
  "Enter an address like zola.com/registry or an email.": "Wpisz adres, np. zola.com/registry, lub adres e-mail.",
  "Multi-Day event?": "Wydarzenie wielodniowe?",
  "Days": "Dni",
  "Timezone: {timezone}": "Strefa czasowa: {timezone}",
  "Search timezone...": "Szukaj strefy czasowej...",
  "Select timezone": "Wybierz strefę czasową",
  "MMMM D, yyyy h:mm a": "D MMMM YYYY HH:mm",
  "dddd, MMMM D, YYYY": "dddd, D MMMM YYYY",
  "ddd, MMM D": "ddd, D MMM",
  "Start Time": "Godzina rozpoczęcia",
  "Event Date and Local Time": "Data i lokalna godzina wydarzenia",
  "Event Date": "Data wydarzenia",
  "Select": "Wybierz",
  "date picker|Choose": "Wybierz",
  "date picker|Not available": "Niedostępne",
  "date picker|Month": "Miesiąc",
  "date picker|Previous Month": "Poprzedni miesiąc",
  "date picker|Next Month": "Następny miesiąc",
  "EEEE, MMMM d, yyyy": "EEEE, d MMMM yyyy",
  "Start time": "Godzina rozpoczęcia",
  "h:mm aa": "HH:mm",
  "date picker|time": "godzina",
  "MMMM d, yyyy h:mm aa": "d MMMM yyyy HH:mm",
  "EEE, MMM d": "EEE, d MMM",
  "Hide the event page? Guests won't be able to open it.": "Ukryć stronę wydarzenia? Goście nie będą mogli jej otworzyć.",
  "Hide the event page?": "Ukryć stronę wydarzenia?",
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again. {count} person on your guest list will lose access.": {
    "one": "Osoby, które kupiły bilety, nie obejrzą transmisji na żywo ani nagrania, dopóki ponownie nie pokażesz strony. {count} osoba z twojej listy gości straci dostęp.",
    "few": "Osoby, które kupiły bilety, nie obejrzą transmisji na żywo ani nagrania, dopóki ponownie nie pokażesz strony. {count} osoby z twojej listy gości stracą dostęp.",
    "many": "Osoby, które kupiły bilety, nie obejrzą transmisji na żywo ani nagrania, dopóki ponownie nie pokażesz strony. {count} osób z twojej listy gości straci dostęp."
  },
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again.": "Osoby, które kupiły bilety, nie obejrzą transmisji na żywo ani nagrania, dopóki ponownie nie pokażesz strony.",
  "{days}-Day Event: {start}": "Wydarzenie {days}-dniowe: {start}",
  "This event isn't unlocked yet. Ask an admin of {team}'s account to unlock it.": "To wydarzenie nie jest jeszcze odblokowane. Poproś administratora konta {team} o jego odblokowanie.",
  "Couldn't load {team}'s events. Try again.": "Nie udało się wczytać wydarzeń konta {team}. Spróbuj ponownie.",
  "Switch to my account": "Przełącz na moje konto",
  "No events yet": "Nie ma jeszcze wydarzeń",
  "Events in {team}'s account will show up here.": "Tutaj pojawią się wydarzenia z konta {team}.",
  "Event unlocked": "Odblokowano wydarzenie",
  "Couldn't unlock this event": "Nie udało się odblokować tego wydarzenia",
  "{team}'s account may not have enough credits. Ask the account holder to add more.": "Na koncie {team} może brakować kredytów. Poproś właściciela konta o dodanie kolejnych."
}
